import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import SvgIcon from "../../../../../parts/SvgIcon";
import { capitalizeFirstLetter, truncateText } from "../../../../../utils/string-helpers";
import { calculateMacros } from "../../../../../utils/nutrition-util";

export const FoodSearchResults = ({ data, isLoading, error, onItemSelect }) => {
  const [showNoResults, setShowNoResults] = useState(false);

  /**
   * UseEffect to add a litte delay to show the not results message
   */
  useEffect(() => {
    let timeout;
    if (!isLoading && !error && data.length === 0) {
      timeout = setTimeout(() => setShowNoResults(true), 1500);
    } else {
      setShowNoResults(false);
      clearTimeout(timeout);
    }

    return () => clearTimeout(timeout);
  }, [data, isLoading, error]);

  if (showNoResults) {
    return (
      <div className="results">
        <div className="status-message">
          <div className="no-results">
            <span className="opacity-70">
              No results found. Try a different search or add a custom food.
            </span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="results">
      {isLoading && (
        <div className="status-message">
          <div className="spinner-div">
            <img src="/img/spinner.gif" width="50" height="50" alt="spinner" />
          </div>
        </div>
      )}

      {!isLoading && error && data.length === 0 && (
        <div className="status-message">
          <div className="no-results">
            <span className="opacity-70">
              Something went wrong. Please try again later.
            </span>
          </div>
        </div>
      )}

      {data.map((item) => {
        const {
          _id,
          quantityNumber = 1,
          quantityDescription = "Serving",
          name,
          type,
          foods = [],
          proteins: itemProteins,
          carbs: itemCarbs,
          fats: itemFats,
          calories: itemCalories,
        } = item;
        const isMeal = type === "meal";
        const isRecipe = type === "recipe";
        const icon = `/img/new-icons/${type}.svg`;
        const quantityDescriptionToShow =
          type === "recipe" && quantityNumber > 1
            ? `${quantityDescription}s`
            : quantityDescription;
        const servings = `${quantityNumber} ${quantityDescriptionToShow}`;

        const itemDetails = {
          itemProteins,
          itemCarbs,
          itemFats,
          itemCalories,
          foodKey: "foodId",
        };

        const { proteins, carbs, fats, calories } = calculateMacros({
          isMeal,
          isRecipe,
          foods,
          itemDetails,
        });

        return (
          <button
            className="content"
            key={_id}
            onClick={() => onItemSelect(item)}
          >
            <div className="info-food">
              <div>
                <span>{name}</span>
              </div>
              <div className="nutrition-info">
                <span className="servings-span">{truncateText(servings, 18)}</span>
                <span>Protein {proteins}g </span>
                <span>&#8226;</span>
                <span>Carbs {carbs}g</span>
                <span>&#8226;</span>
                <span>Fats {fats}g</span>
                <span>&#8226;</span>
                <span>Calories {calories}</span>
              </div>
            </div>
            <div className="identifier">
              <SvgIcon src={icon} noFilterOnLight={false} />
              <span>{capitalizeFirstLetter(type)}</span>
            </div>
          </button>
        );
      })}
    </div>
  );
};

FoodSearchResults.propTypes = {
  data: PropTypes.array,
  isLoading: PropTypes.bool,
  error: PropTypes.string,
  onItemSelect: PropTypes.func.isRequired,
};
